import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin2.module.css";
import styles_modal from "../../Modal/Modal.module.css";
import stylesad2 from "../../../pages/Admin/Admin2.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAddressCard, faArrowLeftRotate,
    faBuilding, faCalendar, faCalendarAlt, faCross,
    faDownload,
    faEdit, faExternalLink, faPlus, faSquareCheck, faUserPlus, faUsers,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {exportToCsv, generateCsv, handleSubmitCsvUsers} from "../../../services/FileService";
import {Field, Form, Formik} from "formik";
import UtilisateursTable from "../Utilisateurs/UtilisateursTable";
import {getUtilisateurs, getUtilisateurStatusIcon} from "../../../services/UserService";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {fetchGetContrats, fetchToSetContratActif} from "../../../services/EntrepriseService";
import TitleMain from "../../Title/TitleMain";
import BtnCopy from "../../Button/BtnCopy";
import {ImageIllustrationUpload} from "../../Image/ImageIllustrationUpload";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";
import TitleSecondary from "../../Title/TitleSecondary";
import {getLabelJourSemaine} from "../../../services/ActivitesService";
import RenderComments from "../../Comment/RenderComment";

function EntrepriseVue2({mode = "consultation", entreprise}) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [data, setData] = useState(entreprise);
    const [afficherSalaries, setAfficherSalaries] = useState(false);
    const [afficherReferents, setAfficherReferents] = useState(false);
    const [afficherSeances, setAfficherSeances] = useState(false);
    const [salaries, setSalaries] = useState([]);
    const [referents, setReferents] = useState([]);
    const [contrats, setContrats] = useState([]);
    const [lienEnrolement, setLienEnrolement] = useState(entreprise?.enrolementLink?.url || "");
    const fileInputRef = useRef(null);

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const toggleContrats = async () => {
        const response = await fetchGetContrats(data.id);
        if (response.success) {
            setContrats(response.data);
            setAfficherSalaries(false);
            setAfficherReferents(false);
            setAfficherSeances(false);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const toggleSalaries = async () => {
        const response = await getUtilisateurs({entreprise: data.id}, "/admin/utilisateurs");
        if (response.success) {
            setSalaries(response.myUtilisateurs);
            setAfficherReferents(false);
            setAfficherSalaries(true);
            setAfficherSeances(false);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const setContratStatus = async (values, {setSubmitting}, contrat) => {
        try {
            const response = await AxiosConfig.post(`/admin/contrat/${contrat.id}/status`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                const responseContrats = await fetchGetContrats(data.id);
                if (responseContrats.success) {
                    setContrats(responseContrats.data);
                } else {
                    console.error("error", responseContrats);
                    handleError(responseContrats.message);
                }
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
        setSubmitting(false);
    }

    const renderContrats = () => {
        return <div style={{display: "flex", flexDirection: "column", gap: "16px", minWidth: "400px"}}>
            <TitleSecondary text={"Contrats"} style={{ margin: 0}}/>

            {contrats.map(contrat => (
                contrat.actif ?
                    <div className={stylesad2.blok} key={contrat.id}>
                        {contrat.label && <h3 style={{ margin: "0 0 12px 0" }}>{contrat.label}</h3>}
                        <Link to={Routing.generate({
                            route: Routing.routes.adminContrat,
                            params: {entrepriseId: entreprise.id, contratId: contrat.id}
                        })} style={{marginBottom: "10px", display: "flex", flexDirection: "row"}}>
                            Du {DateService.formatFrenchDateWithoutTime(contrat.date_start)} au {DateService.formatFrenchDateWithoutTime(contrat.date_end)}
                        </Link>

                        <Formik
                            initialValues={{status: contrat.status ?? "", id: contrat.id}}
                            onSubmit={async (values, {setSubmitting}) => {
                                await setContratStatus(values, {setSubmitting}, contrat);
                            }}
                            enableReinitialize
                        >
                            {({isSubmitting, setFieldValue, values, submitForm}) => {
                                const handleChange = (e) => {
                                    const {name, value} = e.target;
                                    setFieldValue(name, value, false);
                                    submitForm();
                                };

                                return (
                                    <div className={stylesad2.selectContainer}>
                                        {getUtilisateurStatusIcon(contrat.status)}
                                        <Field as="select" name="status" onChange={handleChange}
                                               className={stylesad2.select}>
                                            <option>
                                                -- Sélectionnez un statut --
                                            </option>
                                            <option value={"0"}>
                                                Prospection
                                            </option>
                                            <option value={"1"}>
                                                Activé
                                            </option>
                                            <option value={"2"}>
                                                En résiliation
                                            </option>
                                            <option value={"3"}>
                                                Résilié
                                            </option>
                                        </Field>
                                    </div>
                                );
                            }
                            }
                        </Formik>

                        <p style={{ padding: "4px 6px", borderRadius: "8px", backgroundColor: "#e7eddf", fontSize: ".9rem", width: "fit-content" }}>
                            Référent: <Link to={Routing.generate({
                            route: Routing.routes.adminUtilisateur,
                            params: {utilisateurId: contrat.referent.id}
                        })}>{contrat.referent.prenom} {contrat.referent.nom}</Link>
                        </p>

                        <div style={{marginTop: "18px", marginBottom: "26px"}}>
                            {contrat.activites && contrat.activites.length > 0 ?
                                <>
                                    <span style={{ fontWeight: "500", fontSize: "1.1rem", color:"#333"}}>Activité(s) :</span>
                                    <ul>
                                        {contrat.activites.map((activite, index) => (
                                            <li key={index} style={{ marginTop: "6px", marginBottom: "6px", fontSize: ".9rem" }} title={"Du " + DateService.formatFrenchDateWithoutTime(activite.date_start) +" au "+ DateService.formatFrenchDateWithoutTime(activite.date_end)}>
                                                <Link to={Routing.generate({
                                                    route: Routing.routes.adminActivite,
                                                    params: {entrepriseId: entreprise.id, contratId: contrat.id, activiteId: activite.id}
                                                })}>
                                                    {activite.type.label} -
                                                    {getLabelJourSemaine(activite.jour_semaine).length > 0 ? (
                                                        getLabelJourSemaine(activite.jour_semaine).map((jour, index) => (
                                                            <span key={index}> {jour}{getLabelJourSemaine(activite.jour_semaine).length -2 === index ? " et" : getLabelJourSemaine(activite.jour_semaine).length -1 === index ? "" : ","} </span>
                                                        ))
                                                    ) : (
                                                    <span style={{ fontSize: ".9rem"}}>Pas de créneaux</span>
                                                    )} / {activite.coach.prenom} {activite.coach.nom}
                                                </Link> | <Link to={Routing.generate({
                                                route: Routing.routes.adminSeances,
                                                params: {entrepriseId: entreprise.id, contratId: contrat.id, activiteId: activite.id}
                                            })} style={{ padding: "2px 6px", borderRadius: "4px", backgroundColor: "#e2e4d9", opacity: ".95", fontSize: ".8rem" }}>Voir les séances</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                                : <p style={{ color: "#bd0e0e"}}>Aucune activité associée</p>}
                        </div>

                        {(contrat.max_participations && contrat.max_participations > 1)
                        // || autre option à afficher dans le futur
                            &&
                        <div style={{ marginTop: "8px", marginBottom: "16px", padding: "14px 24px", borderRadius: "8px", backgroundColor: "#f6edea", fontSize: ".9rem", width: "fit-content" }}>
                            <span>Options :</span>
                            <ul style={{listStyle: "inside"}}>
                                {contrat.max_participations && contrat.max_participations > 1 &&
                                <li>
                                    {contrat.max_participations + " participations max par semaine"}
                                </li>
                                }
                            </ul>
                        </div>
                        }

                        <div style={{float: "right", fontSize: ".75rem"}}>
                            <p>Créé le {DateService.formatDate(contrat.date_created)}</p>
                            <p>MAJ le {DateService.formatDate(contrat.date_updated)}</p>
                        </div>
                    </div>
                    : null
            ))}

            <div className={stylesad2.navLink} style={{ justifyContent: "center", margin: "4px 0" }}>
                <Link to={Routing.generate({
                    route: Routing.routes.adminContrats,
                    params: {entrepriseId: data.id}
                })}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Accéder aux contrats
                </Link>
                <Link to={Routing.generate({
                    route: Routing.routes.adminContrats,
                    params: {entrepriseId: data.id},
                    queryParams: {mode: "creation"}
                })}>
                    <AjouterIcone/>
                    Ajouter un contrat
                </Link>
            </div>
        </div>;
    }

    const downloadSalaries = async () => {
        const response = await getUtilisateurs({entreprise: data.id}, "/admin/utilisateurs_csv");
        if (response.success) {
            // Formater response.myUtilisateurs json en csv puis telecharger un csv de response.myUtilisateurs
            exportToCsv("salaries", response.myUtilisateurs);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const toggleReferents = async () => {
        const response = await getUtilisateurs({entreprise: data.id, role: "ROLE_REFERENT"}, "/admin/utilisateurs");
        if (response.success) {
            setReferents(response.myUtilisateurs);
            setAfficherSalaries(false);
            setAfficherReferents(true);
            setAfficherSeances(false);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const toggleSeances = () => {
        setAfficherSeances(!afficherSeances);
        setAfficherSalaries(false);
        setAfficherReferents(false);
    };

    const regenerateEnrolement = async () => {
        showModal('confirm', {
            message: "Cette action désactivera tous les précédents liens d'enrolement de cette entreprise. Continuer ?",
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${data.id}/generate_enrolement`);
                    handleSuccess("Lien généré avec succès");
                    setLienEnrolement(process.env.REACT_APP_URL_FRONT + response.data.enrolementLink.url);
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const setEntrepriseActif = async (actif) => {
        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${data.id}/actif`, {"actif": actif});
            setData(response.data.myEntreprise);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putActifOpenModal = () => {
        const text = data.actif ? "supprimer" : "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette entreprise ?`,
            onConfirm: () => {
                setEntrepriseActif(!data.actif);
                handleSuccess("Enregistré");
            }
        });
    }

    const putActifOpenModalUtilisateur = (utilisateur) => {

    }

    const putActifOpenModalContrat = (contrat) => {
        const text = contrat.actif ? "supprimer" : "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} ce contrat ?`,
            onConfirm: async () => {
                const response = await fetchToSetContratActif(contrat);
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(async () => {
                    const response = await fetchGetContrats(data.id);
                    if (response.success) {
                        setContrats(response.data);
                    } else {
                        console.error("error", response);
                        handleError(response.message);
                    }
                }, 500);
            }
        });
    }

    const handleSubmitCsvUserss = async (values, overwrite = false) => {
        const response = await handleSubmitCsvUsers(values, entreprise.id, overwrite);
        if (response.success) {
            handleSuccess(`${response.msg} - ${response.nbUtilisateursImportes} utilisateur(s) importé(s)`);
        } else {
            handleError(response.msg);
        }
    }

    const handleSubmitCsvUsersPrep = async (values) => {
        showModal('classic', {
            children:
                <div style={{padding: "20px"}}>
                    <h3 className={"titleAlert"}>En cas de mail déjà existant ?</h3>
                    <div className={styles_modal.btnChoiceBar}>
                        <button className="btn btn_main" onClick={() => handleSubmitCsvUserss(values, true)}>Mettre à
                            jour l'utilisateur
                        </button>
                        <button className="btn btn_main" onClick={() => handleSubmitCsvUserss(values, false)}>Ignorer
                            l'utilisateur
                        </button>
                    </div>
                </div>
        });
    }

    const handleSubmitUtilisateurStatus = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/utilisateurs/${values.id}/status`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                if (afficherReferents === true) {
                    toggleReferents();
                }
                if (afficherSalaries === true) {
                    toggleSalaries();
                }
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    useEffect(() => {
        if (!entreprise || !entreprise.id) {
            return;
        }

        setData(entreprise);
        setLienEnrolement(process.env.REACT_APP_URL_FRONT + entreprise.enrolementLink.url);
    }, [user, entreprise]);

    useEffect(() => {
        setTimeout(async () => {
            await toggleContrats();
        }, 100);
    }, [data]);

    if (!data || !data.id) {
        return <p>Chargement ...</p>;
    }


    const handleSubmitLogo = async (values, {setSubmitting, resetForm, setErrors}) => {
        if (values.file) {
            const formData = new FormData();
            formData.append("file", values.file);

            try {
                const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/logo`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.success) {
                    handleSuccess("Logo enregistré avec succès");
                    setData(prevState => ({
                        ...prevState,
                        logo: `${response.data.entreprise}?t=${new Date().getTime()}`
                    }));
                } else {
                    handleError("Logo non enregistré suite à une erreur.");
                }
                resetForm();
            } catch (error) {
                console.error("Erreur lors de l'upload du fichier", error);
            }
        } else {
            setErrors({file: "Un fichier est requis"});
        }

        setSubmitting(false);
    };

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    return (
        <>
            <div className={stylesad2.page_container}>
                <TitleMain text={data.nom}/>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "start",
                    gap: "36px"
                }}>
                    <div style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                        <TitleSecondary text={"Informations"} style={{ margin: 0}}/>

                        <div style={{display: "flex", flexDirection: "column", gap: "10px", maxWidth: "500px"}}
                             className={stylesad2.blok}>

                            <div className={stylesad2.headerBtnsVue}>
                                <button onClick={putActifOpenModal}>
                                    {data.actif ? <><FontAwesomeIcon
                                        icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                                        icon={faSquareCheck}/>Restaurer</>}
                                </button>
                                <Link to={Routing.routes.adminCreation}><FontAwesomeIcon
                                    icon={faEdit}/>Modifier</Link>
                            </div>

                            <ImageIllustrationUpload src={data.logo} alt={data.nom} onClick={handleClick}/>
                            <Formik
                                initialValues={{file: null}}
                                onSubmit={handleSubmitLogo}
                            >
                                {({setFieldValue, submitForm, isSubmitting, errors}) => (
                                    <Form style={{display: "flex", flexDirection: "column"}}>
                                        <input
                                            id="file"
                                            className={stylesad2.inputFileLogo}
                                            name="file"
                                            type="file"
                                            style={{display: 'none'}}
                                            ref={fileInputRef}
                                            onChange={(event) => {
                                                setFieldValue("file", event.currentTarget.files[0]);
                                                submitForm();
                                            }}
                                        />
                                        {errors.file ? <div style={{color: 'red'}}>{errors.file}</div> : null}
                                    </Form>
                                )}
                            </Formik>

                            <div style={{display: "flex", flexDirection: "row", gap: "10px", marginBottom: "15px"}}>
                                <div>
                                    <p style={{
                                        margin: "0 0 32px 0",
                                    }}>{data.description}</p>

                                    <p><FontAwesomeIcon icon={faAddressCard}/> Siret: {data.siret}</p>

                                    <p style={{marginBottom: "10px"}}><FontAwesomeIcon
                                        icon={faBuilding}/>
                                        <a target={"_blank"}
                                           href={`https://www.google.com/maps/place/${
                                               encodeURI(data.addr + " " + data.ville + " " + data.cp + " " + data.pays)
                                           }`}> {data.addr}, {data.ville} {data.cp} - {data.pays}</a>
                                    </p>

                                    <p className={"hide"}>
                                        <FontAwesomeIcon icon={faUsers}/> N nombres de salariés {/* TODO a faire */}
                                    </p>

                                    <p className={"hide"}>
                                        <FontAwesomeIcon icon={faCalendarAlt}/> N nombres de séances
                                        réalisées {/* TODO a faire */}
                                    </p>

                                    <div style={{
                                        outline: "1px solid var(--clr-accent)",
                                        backgroundColor: "var(--clr-bg)",
                                        padding: "6px",
                                        borderRadius: "6px"
                                    }}>
                                        <FontAwesomeIcon icon={faUserPlus}/> Enrolement :
                                        <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "4px"}}>
                                            <Link to={data.enrolementLink.url}
                                                  style={{display: "flex"}}><span style={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                maxWidth: "100%",
                                                overflowWrap: "anywhere",
                                                fontSize: "0.75em",
                                                margin: "8px"
                                            }}>{lienEnrolement}</span></Link>
                                            <BtnCopy copy={lienEnrolement}/>
                                            <button className={`btn_pastille_accent`} onClick={regenerateEnrolement}
                                                    title={"Re-générer un lien"}><FontAwesomeIcon icon={faArrowLeftRotate}/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={stylesad2.navLink}>
                                <Link to={Routing.generate({
                                    route: Routing.routes.adminEntrepriseSalaries,
                                    params: {entrepriseId: data.id}
                                })}>
                                    <FontAwesomeIcon icon={faExternalLink}/>
                                    Accéder aux salariés
                                </Link>
                                <Link to={Routing.generate({
                                    route: Routing.routes.adminUtilisateurs,
                                    queryParams: {mode: "creation_en_masse_csv", entreprise: data.id}
                                })}>
                                    <AjouterIcone/>
                                    Ajouter des salariés depuis un fichier csv
                                </Link>
                                <Link to={Routing.generate({
                                    route: Routing.routes.adminUtilisateurs,
                                    queryParams: {mode: "creation", entreprise: data.id}
                                })}>
                                    <AjouterIcone/>
                                    Ajouter un salarié
                                </Link>
                            </div>
                            <div className={stylesad2.navLink} style={{display: "flex", gap: "10px", margin: "16px 0"}}>
                                <button className={"btn"} onClick={toggleSalaries}>Afficher les salariés</button>
                                <button className={"btn"} onClick={toggleReferents}>Afficher les référents</button>
                                <button className={"btn"} onClick={downloadSalaries}><FontAwesomeIcon
                                    icon={faDownload}/> Exporter les
                                    salariés
                                    (csv)
                                </button>
                                {/*
                              <button onClick={toggleSeances}>Afficher les séances</button>
                            */}

                                {/* caché pour le moment */}
                                <div style={{
                                    display: "none",
                                    flexDirection: "column",
                                    outline: "1px solid var(--clr-accent)",
                                    padding: "16px",
                                    borderRadius: "16px"
                                }}>
                                    <Formik initialValues={{file: null}} onSubmit={handleSubmitCsvUsersPrep}>
                                        {({setFieldValue}) => (
                                            <Form style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                                                <Field name="file">
                                                    {({field}) => (
                                                        <input
                                                            type="file"
                                                            accept=".csv"
                                                            name="file"
                                                            onChange={(event) => {
                                                                setFieldValue("file", event.currentTarget.files[0]);
                                                            }}
                                                        />
                                                    )}
                                                </Field>

                                                <button type="submit" className={stylesad2.btnFileLogo}>Importer des salariés
                                                    (csv)
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>

                                    <div style={{marginTop: "4px"}}>
                                        <button className={"btn"} onClick={generateCsv}
                                                style={{fontSize: "0.75em", padding: "5px", display: "flex", gap: "2px"}}
                                                title={"Télécharger le modèle d'importation des salariés (csv)"}>
                                            <FontAwesomeIcon icon={faDownload} style={{height: "16px"}}/> Modèle
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <p
                                style={{ textAlign: "right", fontSize: ".75rem", margin: "0"}}
                                className={stylesad2.creerParLeBloc}>
                                Créé le {DateService.formatDate(data.created)} par <Link to={Routing.generate({
                                                                                        route: Routing.routes.adminUtilisateur,
                                                                                        params: {utilisateurId: data.createdBy?.id}
                                                                                    })} >
                                {data.createdBy?.prenom} {data.createdBy?.nom}
                            </Link>
                                <br/>
                                {data.updatedBy ? <>MAJ le {DateService.formatDate(data.updated)} par <Link to={Routing.generate({
                                    route: Routing.routes.adminUtilisateur,
                                    params: {utilisateurId: data.updatedBy?.id}
                                })}>{data.updatedBy?.prenom} {data.updatedBy?.nom}</Link></> : null}</p>

                        </div>
                    </div>

                    <div style={{ width: "500px"}}>
                        {renderContrats()}
                    </div>

                    <div style={{ width: "500px"}}>
                        <RenderComments urlGetComments={`/admin/entreprises/${data.id}/comments`} urlAddComment={`/admin/entreprises/${entreprise.id}/add_comment`} data={data} />
                    </div>
                </div>
            </div>

            <div style={{marginBottom: "100px", position: "relative"}}>
                {afficherSalaries &&
                    <UtilisateursTable utilisateurs={salaries} putActifOpenModal={putActifOpenModalUtilisateur}
                                       handleSubmitUtilisateurStatus={handleSubmitUtilisateurStatus}/>}
                {afficherReferents &&
                    <UtilisateursTable utilisateurs={referents} putActifOpenModal={putActifOpenModalUtilisateur}
                                       handleSubmitUtilisateurStatus={handleSubmitUtilisateurStatus}/>}
                {afficherSeances && <div>Séances à venir ... </div>}
            </div>
        </>
    )
}

export default EntrepriseVue2;